module.exports = __webpack_public_path__ + "img/jieju.8e8bb5d6.png";